import _ListDownIcon from "@sk/icons/lib/ListDownIcon";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import React, { useCallback } from 'react';
import cx from 'classnames';
import AntdDropdown from 'antd/lib/dropdown/dropdown';
import { Button } from '../../index';
var DropDown = /*#__PURE__*/React.memo(props => {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    visible = _React$useState2[0],
    setVisible = _React$useState2[1];
  var onVisibleChange = useCallback(() => setVisible(visible => !visible), []);
  if (!props.type) {
    return /*#__PURE__*/React.createElement(AntdDropdown, _extends({
      className: cx({
        'sk-dropdown-btn': !props.color || props.color === 'default',
        'sk-dropdown-white': props.color === 'white'
      })
    }, props));
  } else if (props.type === 'primary') {
    return /*#__PURE__*/React.createElement(AntdDropdown, _extends({}, props, {
      visible: visible,
      onVisibleChange: onVisibleChange
    }), /*#__PURE__*/React.createElement(Button, {
      className: cx({
        'sk-dropdown-btn': !props.color || props.color === 'default',
        'sk-dropdown-white': props.color === 'white'
      })
    }, props.children, visible ? /*#__PURE__*/React.createElement(_ListDownIcon, {
      style: {
        transform: 'rotate(180deg)'
      }
    }) : /*#__PURE__*/React.createElement(_ListDownIcon, null)));
  } else {
    return /*#__PURE__*/React.createElement(AntdDropdown, props);
  }
});
export default DropDown;